
import { CanActivate,ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { INofesh } from "app/nofesh/model/nofesh";
import { ENofeshType } from "../enums/enofesh-type.enum";
import { Injectable } from "@angular/core";

@Injectable({
    providedIn: "root"
})
export class NofeshPnimCanActivateGuard implements CanActivate
{
        
    canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean
    {
        let canActivate: boolean = false;
        let idNofesh: number = (next.children.length > 0) ? next.children[0].params.id : 0;
        let nofashim: INofesh[] = JSON.parse(sessionStorage.getItem("nofashim"));
        if(nofashim && idNofesh > 0)
        {
            let nofesh: INofesh = nofashim.find(n => n.id_nofesh == idNofesh && (n.nofeshType === ENofeshType.NofeshPnim || n.nofeshType === ENofeshType.MeurganimPnim));
            if(nofesh)
            {
                canActivate = true;
            }
        }
        return canActivate;
    }
}